import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { Block, FlexColumn, FlexRow, HeroImage, LargeText, MediumText, OutlinedButton, RouterLink, SmallText } from '@guryou/html-components';
import { today } from '@guryou/html-components/src/calendar/dates';
import { mediumBorderRadius } from '@guryou/html-theme';
import { useTheme } from '@material-ui/core/styles';
import { information } from './HeroInformation';
import Header from '../../../components/navigation';
import SubHeader from '../../../components/navigation/SubHeader';

const HeroSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const date = today();
  const { title, name, description, newTag } = information;

  return (
    <section class={`h-auto sm:h-screen relative flex flex-col items-center justify-start sm:justify-center bg-cover bg-no-repeat bg-center`}>
      <div class={`absolute inset-0 brightness-50 grayscale bg-cover bg-center bg-[url(${HeroImage})] bg-cover bg-center dark bg-invert -z-10`}></div>
      <div class="py-32 px-4 mx-auto max-w-screen-xl text-center lg:py-32 lg:px-12">
        <a
          href="#"
          class="inline-flex justify-between items-center py-1 px-1 pr-4 mb-7 text-sm text-gray-700 bg-gray-100 rounded-full bg-gray-800 text-white hover:bg-gray-200 hover:bg-gray-700"
          role="alert"
        >
          <span class={`text-xs rounded-full text-white px-4 py-1.5 mr-3 bg-[${colors.mandy}]`}>New</span>{' '}
          <span class="text-sm font-medium">{newTag.description}</span>
          <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </a>
        <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl text-white">{title}</h1>
        <p class="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 text-gray-400">{description}</p>
        <div class="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
          <a
            href="#"
            class={`inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-[${colors.mandy}] hover:bg-primary-800`}
          >
            Learn more
            <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </a>
          <a
            href="#"
            class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 text-white border-gray-700 hover:bg-gray-700 focus:ring-gray-800"
          >
            <svg class="mr-2 -ml-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"></path>
            </svg>
            Watch video
          </a>
        </div>
        <section>
          <div class="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
            <dl class="grid max-w-screen-md gap-8 mx-auto text-gray-900 sm:grid-cols-3 text-white">
              <div class="flex flex-col items-center justify-center">
                <dt class="mb-2 text-3xl md:text-4xl font-extrabold">73M+</dt>
                <dd class={`font-light text-[${colors.mandy}]`}>centros</dd>
              </div>
              <div class="flex flex-col items-center justify-center">
                <dt class="mb-2 text-3xl md:text-4xl font-extrabold">1B+</dt>
                <dd class={`font-light text-[${colors.mandy}]`}>professionisti</dd>
              </div>
              <div class="flex flex-col items-center justify-center">
                <dt class="mb-2 text-3xl md:text-4xl font-extrabold">4M+</dt>
                <dd class={`font-light text-[${colors.mandy}]`}>utentes</dd>
              </div>
            </dl>
          </div>
        </section>
      </div>
    </section>
  );
};

export default HeroSection;
